<div class="app-shell" *ngIf="authState === 'ready'">
  <app-top-nav></app-top-nav>
  <div class="app-body">
    <app-sidebar
      [activeModule]="activeModule"
      (moduleSwitch)="onModuleSwitch($event)"
    ></app-sidebar>
    <app-onboarding-view
      [activeModule]="activeModule"
      [moduleConfig]="moduleConfig"
    ></app-onboarding-view>
  </div>
  <app-footer></app-footer>
</div>

<!-- Blocking auth overlay — non-dismissible, shown during connect + on error -->
<div class="auth-overlay" *ngIf="authState === 'connecting' || authState === 'error'">
  <div class="auth-card">

    <div class="auth-brand">
      <span class="auth-brand-name">Injest.IQ</span>
    </div>

    <h2 class="auth-title">Open from Kepler or Rubin</h2>
    <p class="auth-subtitle">
      This app requires an authentication token from Kepler or Rubin.
      It cannot be opened directly via URL.
    </p>

    <div class="auth-steps">
      <div class="auth-step">
        <span class="step-num">1</span>
        <span>Close this tab.</span>
      </div>
      <div class="auth-step">
        <span class="step-num">2</span>
        <span>Open <strong>Kepler</strong> or <strong>Rubin</strong> and log in.</span>
      </div>
      <div class="auth-step">
        <span class="step-num">3</span>
        <span>Click the <strong>Injest.IQ</strong> icon in the nav bar.</span>
      </div>
    </div>

  </div>
</div>
